import Vue from 'vue';
import App from './App.vue';
import router from "@router";
import store from "@store";
import i18n from '@i18n';
import Fragment from 'vue-fragment';
import VueRouter from "vue-router";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import VueEllipseProgress from 'vue-ellipse-progress';
import VueMasonry from 'vue-masonry-css'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import ToggleButton from 'vue-js-toggle-button'
import { ResizeObserver } from 'vue-resize'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import vueAwesomeCountdown from 'vue-awesome-countdown'

Vue.config.productionTip = false

import Toast from "vue-toastification";
import { ToastOptions } from "@plugins/vue-toastification"; // custom
import "vue-toastification/dist/index.css";
Vue.use(Toast, ToastOptions);

import vueLazyload from 'vue-lazyload'
Vue.use(vueLazyload, { preLoad: 1.3 })

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps);

import Datepicker from "@custom_modules/vuejs-datepicker";
Vue.component('date-picker', Datepicker)


Vue.use(ToggleButton)
Vue.use(Fragment.Plugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueEllipseProgress);
Vue.use(VueMasonry);
Vue.use(PerfectScrollbar);
Vue.use(vueAwesomeCountdown, 'vac')

if (router.history._startLocation.startsWith("/design-iframe")) {
  store.dispatch('setModule', { module: "designIframe" });
} else {
  store.dispatch('setModule', { module: "design" });
}

Vue.component('resize-observer', ResizeObserver)
// Vue.component("default-layout", require("./layouts/Default.vue").default);
// Vue.component("design-iframe-layout", require("./layouts/DesignIframe.vue").default);
// Vue.component("blank-layout", require("./layouts/Blank.vue").default);
// Vue.component("design-preview-layout", require("./layouts/DesignPreview.vue").default);
Vue.component("OverlayLayout", require("@components_system/Design/Sidebar/Overlay/OverlayLayout").default);
Vue.component("Filemanager", require("@components_system/Design/Modal/Filemanager/Filemanager.vue").default);
Vue.component("CustomPicture", require("@components/dynamic/widget/Share/Picture.vue").default);
Vue.component("CustomPicture2", require("@components/dynamic/widget/Share/Picture2.vue").default);
Vue.component("ImageSlide", require("@components/dynamic/widget/Share/imageSlide.vue").default);
Vue.component("Link", require("@components/shared/Link.vue").default);
Vue.component("MoneyFormat", require("@components/shared/MoneyFormat.vue").default);

import helperPlugin from '@helpers/helpers.plugin'
Vue.use(helperPlugin);

import errorHandler from '@plugins/error-handler'
errorHandler({ app: Vue, store });

new Vue({
  i18n,
  router,
  store,

  beforeCreate() {
    this.$store.dispatch('initialiseStore');
  },

  beforeDestroy() {
    this.$store.dispatch('destroyStore');
  },
  render: h => h(App),
}).$mount('#app')


// import { gsap } from "gsap";
    
// import { CustomEase } from "gsap/CustomEase";
// import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";
    
// import { Flip } from "gsap/Flip";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Observer } from "gsap/Observer";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { Draggable } from "gsap/Draggable";
// import { MotionPathPlugin } from "gsap/MotionPathPlugin";
// import { EaselPlugin } from "gsap/EaselPlugin";
// import { PixiPlugin } from "gsap/PixiPlugin";
// import { TextPlugin } from "gsap/TextPlugin";


// gsap.registerPlugin(Flip,ScrollTrigger,Observer,ScrollToPlugin,Draggable,MotionPathPlugin,EaselPlugin,PixiPlugin,TextPlugin,RoughEase,ExpoScaleEase,SlowMo,CustomEase);
